
































































































import {
  MemberManagementMemberPointDTO,
  MemberManagementMemberPointService as memberPointApi,
} from "@/common/api";
import QErrors from "@/common/qErrors.vue";
import QNotify from "@/common/qNotify";
import QPopupPaginate from "@/common/qPopupPaginate.vue";
import QPopupTableHeader from "@/common/qPopupTableHeader.vue";
import { TYPES } from "@/model/memberPoint";
import PaginateModel from "@/model/paginate";
import { Component, Vue } from "vue-property-decorator";

@Component({
  name: "MemberPointHistoryComponent",
  components: {
    QErrors,
    QPopupTableHeader,
    QPopupPaginate,
  },
})
export default class MemberPointHistoryComponent extends Vue {
  public isShow = false;
  public pagination = new PaginateModel({
    page: 0,
    pageCount: 0,
    start: 0,
    end: 0,
    count: 0,
  });
  public memberId = null;

  public headers = [];

  public initHeaders = [
    { id: "created_at", name: "日時", order: "desc" },
    { id: "type", name: "区分", order: "" },
    { id: "note", name: "備考" },
    { id: "give_point", name: "獲得pt" },
    { id: "use_point", name: "利用pt" },
  ];

  public initSearch = {
    types: ["all"],
    startDate: null,
    endDate: null,
    orderCode: null,
    sort: "created_at",
    direction: "desc",
    perPage: 30,
    page: 1,
  };

  public searchParams: any = {};

  public pointHistories: MemberManagementMemberPointDTO[] = [];

  public initPoint = {
    type: TYPES.LIVE_CARP,
    note: null,
    givePoint: null,
  };

  public point: any = null;

  public errors = {};

  public typeOptions = [];

  public async show(memberId) {
    this.$el.querySelector(".mb__responsive-table").scrollTop = 0;
    this.point = null;
    this.pointHistories = [];
    this.isShow = true;
    this.memberId = memberId;
    this.headers = JSON.parse(JSON.stringify(this.initHeaders));
    this.searchParams = { ...this.initSearch };

    await this.getList();
  }

  public async getList() {
    let message: any;
    try {
      const result = await memberPointApi.adminMemberPoint({
        ...this.searchParams,
        ...{ memberId: this.memberId },
      });

      this.pagination = new PaginateModel({
        page: result.data.paginator.currentPage,
        pageCount: result.data.paginator.lastPages,
        start: result.data.paginator.currentPage,
        end: result.data.paginator.lastPages,
        count: result.data.paginator.total,
      });
      this.pointHistories = result.data.memberPoints;
      this.typeOptions = result.data.types;
    } catch (error) {
      message = error.body.message;
      QNotify.error({
        text: message,
      });
    }
  }

  public doSearch(query) {
    this.searchParams = {
      ...this.searchParams,
      ...query,
    };
    this.getList();
  }

  public addPoint() {
    this.point = { ...this.initPoint };
  }

  public async update() {
    try {
      await memberPointApi.adminMemberPointCreate({
        ...this.point,
        ...{ memberId: this.memberId },
      });

      QNotify.success({
        text: this.$t("common.message.created"),
      });

      this.point = null;
      await this.getList();
    } catch (error) {
      QNotify.error({
        text: error.body.message,
      });
      this.errors = error.body.errors;
    }
  }

  public closePopup() {
    if (this.point) {
      this.$modal.showCancel({
        text: `${this.$t("common.message.cancel_confirm")}`,
        onConfirm: () => {
          this.isShow = false;
          this.$emit("close");
        },
      });
    } else {
      this.isShow = false;
      this.$emit("close");
    }
  }

  public changeInput(key) {
    this.errors = { ...this.errors, ...{ [key]: [] } };
  }
}
